import type { TrackableAction } from '@apps/clos-sessions/state/processing';
import type { SignInProvider, ClosUser } from './types';

export class SignIn implements TrackableAction {
  readonly track = true;

  constructor(public payload: { provider: SignInProvider }) {}

  static readonly type = '[Auth] Sign In';
}

export class SignOut implements TrackableAction {
  readonly track = true;

  static readonly type = '[Auth] Sign Out';
}

export class PatchUser {
  constructor(public payload: ClosUser) {}

  static readonly type = '[Auth] Patch User';
}

export class RefreshToken implements TrackableAction {
  readonly track = true;

  static readonly type = '[Auth] Refresh Token';
}
